export default {
	"name": "Braze",
	"stage": "integration",
	"mandanten": ["2", "2003", "4", "4002", "37", "37002", "51", "51003", "55"],
	"pagetypes": "all",
	"excludedPagetypes": ["login", "bestelluebersicht"],
	"serviceSettings": {
		"2": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "410ab6df-664c-4d2b-8b73-9318ca1ef909",
			"showInAppMessages": true,
			"useServiceWorker": true
		},
		"2003": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "410ab6df-664c-4d2b-8b73-9318ca1ef909",
			"showInAppMessages": false,
			"useServiceWorker": false
		},
		"4": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "b9b4c172-7cfb-46e7-afb5-e908dabe73f1",
			"showInAppMessages": true,
			"useServiceWorker": true
		},
		"4002": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "b9b4c172-7cfb-46e7-afb5-e908dabe73f1",
			"showInAppMessages": false,
			"useServiceWorker": false
		},
		"37": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "efbab2f7-1d37-407e-acc6-e7cfcba3401b",
			"showInAppMessages": true,
			"useServiceWorker": true
		},
		"37002": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "efbab2f7-1d37-407e-acc6-e7cfcba3401b",
			"showInAppMessages": false,
			"useServiceWorker": false
		},
		"51": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "774727b1-491b-4e85-8c79-afe9bd2fb469",
			"showInAppMessages": true,
			"useServiceWorker": true
		},
		"51003": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "774727b1-491b-4e85-8c79-afe9bd2fb469",
			"showInAppMessages": false,
			"useServiceWorker": false
		},
		"55": {
			"sdkEndpoint": "sdk.fra-02.braze.eu",
			"apiKey": "1bc335d4-e857-411c-9d91-bec3650352ca",
			"showInAppMessages": true,
			"useServiceWorker": true
		}
	}
}
